



















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-brands-popular-brands-slider',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() private items: Array<object>;

  private bannerCode: string = '';

  private created(): void {
    this.bannerCode = 'brand-slider';
  }

  private slideOptions: object = {
    slidesPerView: 'auto',
    threshold: 2,
    breakpoints: {
      768: {
        navigation: {
          nextEl: `${this.bannerCode} ._next`,
          prevEl: `${this.bannerCode} ._prev`
        }
      }
    }
  };
}
